<template>
  <div class="">
    <all-header></all-header>

    <div class="login-bj">
      <div class="login-left"></div>
      <div class="login-fillin">
        <div class="login-logo">
          <img src="../../public/images/logo1.png" />
        </div>
        <div class="login-title">世界至德</div>

        <div class="reinfo-box">
          <div class="login-Inp">
            <el-input
              v-model="frominfo.name"
              class="logIn"
              placeholder="请输入用户名"
              prefix-icon="el-icon-user"
            >
            </el-input>
          </div>

          <div class="login-Inp">
            <el-input
              v-model="frominfo.mobile"
              class="logIn"
              placeholder="请输入手机号"
              prefix-icon="el-icon-phone-outline"
            >
            </el-input>
          </div>

          <div class="login-yanz">
            <el-input
              v-model="frominfo.code"
              type="code"
              class="logIn"
              placeholder="验证码"
              prefix-icon="el-icon-cloudy"
            >
            </el-input>
            <el-button type="primary" @click="iphone" :disabled="disable"
              >{{ buttonName }}
            </el-button>
          </div>

          <div class="login-Inp">
            <el-input
              v-model="frominfo.password"
              type="password"
              class="logIn"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
            >
            </el-input>
          </div>

          <div class="login-Inp">
            <el-input
              v-model="frominfo.password_confirmation"
              type="password"
              class="logIn"
              placeholder="请再次输入密码"
              prefix-icon="el-icon-lock"
            >
            </el-input>
          </div>

          <div class="login-goin" @click="replace()">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import AllHeader from "../components/Header.vue"; //公用头部
export default {
  components: {
    AllHeader,
  },
  inject: ["reload"], //引入刷新页面
  data() {
    return {
      buttonName: "获取验证码", //获取验证码文案
      count: 120, //倒计时
      disable: false, //获取验证码是否可点
      frominfo: {
        //忘记密码数据
        mobile: "", //手机号
        code: "", //code
        name: "", //用户名
        password: "", //新密码
        password_confirmation: "", //再次输入新密码
      },
    };
  },
  created() {},
  methods: {
    //获取验证码
    iphone() {
      var lay = this.$layer;
      if (!this.frominfo.mobile) {
        this.$layer.msg("请先输入手机号");
        return;
      }

      try {
        this.$http
          .post("send/code", {
            mobile: this.frominfo.mobile,
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.$layer.msg("发送成功");
              var timeout = setInterval(() => {
                if (this.count < 1) {
                  this.disable = false;
                  this.buttonName = "获取验证码";
                  this.count = 120;
                  clearInterval(timeout);
                } else {
                  this.disable = true;
                  this.buttonName = this.count-- + "s 后重新获取";
                }
              }, 1000);
            } else {
              this.$layer.msg(res.data.message);
            }
          })
          .catch(function (error) {
            // handle error
            console.log(error);
            lay.msg("error");
          });
      } catch (e) {
        this.$layer.msg(e);
      }
    },

    //注册确认
    replace() {
      var lay = this.$layer;
      if (!this.frominfo.name) {
        this.$layer.msg("请输入用户名");
        return;
      }

      if (!this.frominfo.mobile) {
        this.$layer.msg("请输入手机号");
        return;
      }

      if (!this.frominfo.code) {
        this.$layer.msg("请输入验证码");
        return;
      }

      if (!this.frominfo.password) {
        this.$layer.msg("请输入密码");
        return;
      }

      if (this.frominfo.password.length < 6) {
        this.$layer.msg("请输入最少6位数密码");
        return;
      }

      if (this.frominfo.password != this.frominfo.password_confirmation) {
        this.$layer.msg("两次密码不一致");
        return;
      }

      try {
        this.$layer.loading();
        this.$http
          .post("register", this.frominfo, {})
          .then((res) => {
            this.$layer.closeAll("loading");
            if (res.data.code == 200) {
              this.$layer.msg(res.data.message);
              setTimeout(() => {
                (this.frominfo = {
                  mobile: "",
                  code: "",
                  name: "",
                  password: "",
                  password_confirmation: "",
                }),
                  this.$router.push({ name: "login" });
              }, 1500);
            } else {
              this.$layer.closeAll("loading");
              this.$layer.msg(res.data.message);
            }
          })
          .catch(function (error) {
            // handle error
            console.log(error);
            lay.msg("error");
          });
      } catch (e) {
        this.$layer.msg(e);
      }
    },
  },
};
</script>
  
  <style scoped>
.login-bj {
  width: 100%;
  height: 79vh;
  position: relative;
  margin-top: 15vh;
}

.login-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 21%; /* 容器宽度占满屏幕*/
  height: 85vh;
  background: url(../../public/images/dlbg.png) no-repeat;
  background-size: 100% 100%;
}

.login-fillin {
  position: absolute;
  top: 52%;
  left: 50%;
  width: 30%;
  background: #ffffff;
  border-radius: 0px 5px 5px 0px;
  transform: translate(-20%, -50%);
}
.login-logo {
  text-align: center;
}
.login-logo img {
  width: 100px;
  height: 110px;
}
.login-title {
  font-weight: bold;
  font-size: 38px;
  color: #333333;
  text-align: center;
  margin-top: 20px;
}

.register-tl {
  position: relative;
  width: 100%;
  height: 480px;
}
.register-tl img {
  width: 100%;
  height: 480px;
}
.register-info {
  position: relative;
  width: 1140px;
  margin: -130px auto 0;
  background: #fff;
  border-radius: 5px 5px 0px 0px;
  padding: 0 30px;
}
.reinfo-title {
  font-size: 42px;
  font-family: Arial-BoldMT, Arial;
  font-weight: bold;
  color: #282828;
  padding: 27px 0;
  border-bottom: 1px solid #d8d8d8;
}
.reinfo-box {
  width: 100%;
  margin: 20px auto 0;
}

.login-Inp {
  margin-bottom: 20px;
}
.login-name {
  font-size: 16px;
  margin-bottom: 14px;
}
.login-yanz {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

::v-deep .login-yanz .el-button {
  margin-left: 20px;
}

.login-goin {
  width: 100%;
  background: linear-gradient(118deg, #c04549 0%, #9f2227 100%);
  border-radius: 10px;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  line-height: 48px;
  cursor: pointer;
}

.login-ret {
  display: block;
  width: 100%;
  background: #d8d8d8;
  border-radius: 10px;
  font-weight: 400;
  font-size: 18px;
  color: #666;
  text-align: center;
  line-height: 48px;
  cursor: pointer;
  margin-top: 30px;
}
</style>